<template>
  <v-container fluid class="pa-0 ma-0">
    <v-app-bar color="#1C638F" dark app v-if="TelaMenor">
      <div class="d-flex justify-center align-center" style="width: 100%;">
        <v-btn
          v-for="(item, index) in menu_itens"
          :key="index"
          icon
          @click="navegar(item.route)"
          :title="item.text"
          style="margin: 0 8px;"
        >
          <v-icon size="24">{{ item.icon }}</v-icon>
        </v-btn>
      </div>
    </v-app-bar>
    <v-navigation-drawer
      v-else
      v-model="drawer"
      app
      :permanent="false"
      width="300"
      color="#1C638F"
      dark
    >
      <v-list-item class="mt-6 mb-2 d-flex justify-center">
        <div style="width: 150px; height: 100px;">
          <img
            src="@/assets/logo_branca.png"
            alt="Logo"
            style="object-fit: contain; width: 100%; height: 100%; border-radius: 0;"
          />
        </div>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item
          v-for="(item, index) in menu_itens"
          :key="index"
          @click="navegar(item.route)"
          link
          :class="{ 'active-menu': item.active }"
          style="margin-bottom: 10px;"
        >
          <v-list-item-icon>
            <v-icon size="28">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title style="font-size: 1.0em; font-weight: 600;">
              {{ item.text.toUpperCase() }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-spacer></v-spacer>
      <v-list>
        <v-list-item @click="logout()" style="color: #ff5252;">
          <v-list-item-icon>
            <v-icon size="24" style="color: #ff5252;">mdi-exit-to-app</v-icon>
          </v-list-item-icon>
          <v-list-item-title style="font-weight: bold; color: #ff5252;">SAIR</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <v-container fluid class="pa-0" style="position:relative;">
        <v-btn
          icon
          small
          color="#1C638F"
          style="position: absolute; top: 12px; left: 12px; z-index: 1001;"
          @click="drawer = !drawer"
          v-if="!TelaMenor"
        >
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <div style="padding-top: 40px;">
          <router-view></router-view>
        </div>
      </v-container>
    </v-main>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      largura_tela: 0,
      drawer: true
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    menu_itens () {
      return [
        { icon: 'mdi-account-multiple', text: 'Fisioterapeutas', route: '/fisioterapeutas' },
        { icon: 'mdi-account-heart', text: 'Pacientes', route: '/pacientes' },
        { icon: 'mdi-calendar-check', text: 'Atendimentos', route: '/consultas' },
        { icon: 'mdi-comment-text-multiple-outline', text: 'Avaliações', route: '/avaliacoes'},
        { icon: `mdi-bell`, text: 'notificações', route: '/notificacoes'},
        // { icon: 'mdi-chart-bar', text: 'Relatórios', route: '/relatorios' },
        { icon: 'mdi-cog', text: 'Configurações', route: '/configuracoes' }
      ]
    },
    TelaMenor () {
      return this.largura_tela < 1264
    }
  },
  created () {
    this.largura_tela = window.innerWidth
  },
  methods: {
    navegar(route) {
      if (this.$route.path !== route) {
        this.$router.push(route)
      }
    },
    logout() {
      this.$store.dispatch('signUserOut').then(() => {
        this.$router.push('/')
      })
    }
  }
}
</script>